( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'treatment-planner-phone', COMPONENT );
} )( app );
